import React from 'react';
import { IconButton } from '@material-ui/core';
import * as Icons from '@material-ui/icons'
import './input-round.scss';

const InputRound = ({ register, type, placeholder, name, errors, messageError, resetError, hidden, edgeStatus, setPasswordStatus }) => {
    
    return(
        <div className="f-input-round" hidden={hidden}  >
            <input className="f-input-round-field" 
                onFocus={messageError ? resetError : undefined }
                name={name}
                ref={register}  type={type} placeholder={placeholder} />
                {type === "password" || (type !== "password" && edgeStatus) ?
                <div className="f-pwd-edge">
                <IconButton
                    edge="end"
                    aria-label="toggle password visibility"
                    onClick={() => { setPasswordStatus(!edgeStatus)}}
                    onMouseDown={ e => e.preventDefault()}
                >
                    {edgeStatus? <Icons.VisibilityOff className="f-btn-password" /> : <Icons.Visibility className="f-btn-password" />}
                </IconButton>
                </div>
                : 
                <></>
                }
            {errors[name] && <span className="f-input-round-span">{errors[name].message}</span>}
            {!errors[name] && messageError && <span className="f-input-round-span">{messageError}</span>}
        </div>
    )
};

export default InputRound;